import { createStore as createReduxStore, Store, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import { rootReducer } from '../reducers';

export const createStore = (): Store => {
  return createReduxStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
};
